module.exports = __webpack_public_path__ + "img/arrow_up.828cc4cc.png";